import React, { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import SmsMarketingConsent from "./SmsMarketingConsent";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../../contexts/Context";
import { IoCloseOutline, IoLogoInstagram } from "react-icons/io5";
import moment from 'moment';
import {
    getAssetUrl,
    getCompanyAddress,
    getCompanyPhone,
    getInstagramInfo,
    getOperatingHours
} from "./loginDisplayUtil";

const CustomerEdit = ({ show, setShow, setShowError, setError, onSubmit }) => {
 
    const [displayShow, setDisplay] = useState(show ? "flex" : "none");
    const [canEditDob, setCanEditDob] = useState(false);
    const dobEditabilitySet = useRef(false);
    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const {
        lanIndex, customer, company, bgImg, landingImg, otherUrls, openingTime,
        closingTime, mustDob, hideOptionalField
    } = React.useContext(UserContext);
    const { addCustomer } = React.useContext(ActionContext);

    useEffect(() => {
        setDisplay(show ? "flex" : "none");

        if (!show) {
            setCanEditDob(false);
            dobEditabilitySet.current = false;
        } else if (customer && !dobEditabilitySet.current) {
            setCanEditDob(customer.dob === 0 || customer.dob === "0");
            dobEditabilitySet.current = true;
        }
    }, [show, customer]);


    const handleChange = (value, name) => {
        let cus = JSON.parse(JSON.stringify(customer || {}));
        cus[name] = value;
        addCustomer(cus);
    }

    const handleSubmit = () => {
        if (!customer) return;

        const submitCustomer = { ...customer };

        if (submitCustomer.phone === "" || submitCustomer.phone.length < 7 || submitCustomer.phone.length > 15) {
            setError([{ errorMessage: "Phone no cannot be less than 7 or greater than 15" }]);
            return setShowError(true);
        } else if (submitCustomer.pdpa === 0 || submitCustomer.pdpa === "0") {
            setError([{ errorMessage: "Must agree the terms & condition" }]);
            return setShowError(true);
        } else if (mustDob) {
            if (typeof submitCustomer.dob === "string" && !moment(submitCustomer.dob, "DDMMYYYY").isValid()) {
                setError([{ errorMessage: "Incorrect DOB Format" }]);
                return setShowError(true);
            }
            if (typeof submitCustomer.dob === 'string')
                submitCustomer.dob = moment(submitCustomer.dob, "DDMMYYYY").valueOf();

            if (submitCustomer.dob === 0) {
                setError([{ errorMessage: "Please Input your DOB" }]);
                return setShowError(true);
            }
        } else if (!mustDob) {
            if (!moment(submitCustomer.dob, "DDMMYYYY").isValid()) {
                submitCustomer.dob = 0;
            } else {
                submitCustomer.dob = moment(submitCustomer.dob, "DDMMYYYY").valueOf();
            }

        }

        onSubmit(submitCustomer)
    }

    const operatingHours = getOperatingHours(openingTime, closingTime);
    const companyAddress = getCompanyAddress(company);
    const companyPhone = getCompanyPhone(company);
    const instagramInfo = getInstagramInfo(otherUrls);

    return (
        <React.Fragment>
            <EditBackdrop display={displayShow} onClick={() => setShow(false)} />
            <ModalContainer display={displayShow} bgImg={bgImg} themeContext={themeContext}>
                <IconButton onClick={() => setShow(false)}>
                    <IoCloseOutline size={34} />
                </IconButton>
                <ContentWrapper>
                    <FormSection>
                        <ImgWrapper image={company && company.companyLogo} />
                        <TitleText>EDIT ACCOUNT</TitleText>
                        <Divider />
                        {!hideOptionalField &&
                            <React.Fragment>
                                <SectionTitle>PERSONAL INFORMATION</SectionTitle>
                                <GenderRow>
                                    <RadioLabel>
                                        <RadioInput
                                            name="gender"
                                            value={0}
                                            checked={`${customer && customer.gender}` === "0"}
                                            type="radio"
                                            onChange={(e) => { handleChange(e.target.value, "gender") }}
                                        />
                                        Mr.
                                    </RadioLabel>
                                    <RadioLabel>
                                        <RadioInput
                                            name="gender"
                                            value={1}
                                            checked={`${customer && customer.gender}` === "1"}
                                            type="radio"
                                            onChange={(e) => { handleChange(e.target.value, "gender") }}
                                        />
                                        Mrs.
                                    </RadioLabel>
                                </GenderRow>
                                <Input
                                    value={customer ? customer.customerName || "" : ""}
                                    type="text"
                                    onChange={(e) => { handleChange(e.target.value, "customerName") }}
                                    placeholder={`${languageContext[lanIndex].name}*`}
                                    aria-label={languageContext[lanIndex].name}
                                />
                            </React.Fragment>
                        }
                        <Input
                            value={customer ? customer.phone || "" : ""}
                            type="tel"
                            onChange={(e) => { handleChange(e.target.value, "phone") }}
                            placeholder={`${languageContext[lanIndex].phone}*`}
                            aria-label={languageContext[lanIndex].phone}
                        />
                        {!hideOptionalField &&
                            <Input
                                value={customer ? customer.email || "" : ""}
                                type="email"
                                onChange={(e) => { handleChange(e.target.value, "email") }}
                                placeholder={`${languageContext[lanIndex].email} (${languageContext[lanIndex].optional})`}
                                aria-label={languageContext[lanIndex].email}
                            />
                        }
                        {mustDob &&
                            <Input
                                value={customer ? typeof customer.dob === "number" ? moment(customer.dob).format("DDMMYYYY") : customer.dob : ""}
                                type="text"
                                onChange={(e) => { handleChange(e.target.value, "dob") }}
                                readOnly={!canEditDob}
                                placeholder={`${languageContext[lanIndex].dob} (DDMMYYYY)`}
                                aria-label={languageContext[lanIndex].dob}
                                aria-readonly={!canEditDob}
                            />
                        }
                        {!hideOptionalField &&
                            <Input
                                type="password"
                                value={customer ? customer.userPassword || "" : ""}
                                onChange={(e) => { handleChange(e.target.value, "userPassword") }}
                                placeholder="Password"
                                aria-label="Password"
                            />
                        }
                        <SmsMarketingConsent
                            checked={customer && customer.smsMarketingConsent === true}
                            onChange={(checked) => handleChange(checked, "smsMarketingConsent")}
                        />
                        <SaveButton themeContext={themeContext} onClick={handleSubmit} >
                            {languageContext[lanIndex].edit}
                        </SaveButton>
                    </FormSection>
                    {(landingImg || operatingHours || companyPhone || companyAddress || instagramInfo) &&
                        <FooterInfo>
                            {landingImg && <FooterLandingImage image={landingImg} />}
                            {operatingHours && <FooterLine>{operatingHours}</FooterLine>}
                            {companyPhone && <FooterLine>{companyPhone}</FooterLine>}
                            {companyAddress && <FooterAddress>{companyAddress}</FooterAddress>}
                            {instagramInfo && instagramInfo.url &&
                                <InstagramLink href={instagramInfo.url} target="_blank" rel="noopener noreferrer">
                                    <IoLogoInstagram size={46} />
                                    {instagramInfo.handle && <InstagramHandle>{instagramInfo.handle.split("?")[0]}</InstagramHandle>}
                                </InstagramLink>
                            }
                        </FooterInfo>
                    }
                </ContentWrapper>
            </ModalContainer>
        </React.Fragment >
    );
}

export default CustomerEdit;
const EditBackdrop = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: ${(props) => props.display};
        position: fixed;
        inset: 0;
        z-index: 1000;
        background: rgba(0, 0, 0, 0.58);
        animation: customerEditBackdrop 180ms ease-out;

        @keyframes customerEditBackdrop {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    }
`;

const SaveButton = styled.div`
    display: flex;
    width: 68%;
    max-width: 360px;
    min-height: 62px;
    margin: 14px auto 0;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: 400;
    border-radius: 34px;
    background-color: #5f5f5f;
    color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.18);
    cursor: pointer;

    @media (max-height: 760px) {
        min-height: 54px;
        font-size: 20px;
    }
`;

const ImgWrapper = styled.div`
    width: 220px;
    max-width: 78%;
    height: 110px;
    margin: 0 0 20px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        width: 180px;
        height: 88px;
        margin-bottom: 14px;
    }
`;

const Input = styled.input`
    width: 100%;
    min-height: 64px;
    border-radius: 12px;
    padding: 0 20px;
    font-size: 20px;
    border: 1px solid #9d9d9d;
    margin-bottom: 12px;
    background-color: rgba(255,255,255,0.94);
    color: #343434;
    box-sizing: border-box;
    outline: none;

    &::placeholder {
        color: #a9a9a9;
    }

    @media (max-height: 760px) {
        min-height: 56px;
        font-size: 18px;
        margin-bottom: 10px;
    }
`;

const IconButton = styled.div`
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 99;
    color: #555555;
    cursor: pointer;
`;

const TitleText = styled.div`
    color: #333333;
    font-size: 28px;
    font-weight: 300;
    line-height: 1;
    text-align: center;

    @media (max-height: 760px) {
        font-size: 24px;
    }
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    margin: 24px 0 20px;
    background-color: rgba(80,80,80,0.45);
`;

const SectionTitle = styled.div`
    align-self: flex-start;
    margin-bottom: 24px;
    font-size: 17px;
    font-weight: 700;
    color: #444444;
    letter-spacing: 0;
`;

const GenderRow = styled.div`
    display: flex;
    align-self: flex-start;
    gap: 18px;
    margin-bottom: 18px;
`;

const RadioLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 18px;
    color: #444444;
`;

const RadioInput = styled.input`
    width: 22px;
    height: 22px;
    margin: 0;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100dvh;
    box-sizing: border-box;
    padding: 44px 32px 34px;
    overflow-y: auto;
    gap: 34px;

    @media (max-height: 760px) {
        padding-top: 28px;
        gap: 24px;
    }

    @media (min-width: 768px) {
        min-height: 0;
        max-height: calc(100dvh - 80px);
        padding: 38px 36px 32px;
        overflow-y: auto;
    }
`;

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    padding-top: 16px;
`;

const FooterInfo = styled.div`
    width: 100%;
    max-width: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #555555;
    text-align: center;
`;

const FooterLandingImage = styled.div`
    width: 80%;
    height: 100px;
    margin-top: 100px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        height: 72px;
    }
`;

const FooterLine = styled.div`
    margin-top: 6px;
    font-size: 21px;
    line-height: 1.15;
`;

const FooterAddress = styled.div`
    max-width: 430px;
    margin-top: 10px;
    font-size: 15px;
    font-style: italic;
    line-height: 1.25;
`;

const InstagramLink = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 42px;
    color: #555555;
    text-decoration: none;

    @media (max-height: 760px) {
        margin-top: 24px;
    }
`;

const InstagramHandle = styled.div`
    font-family: "contralto-xsmall", sans-serif;
    font-size: 14px;
`;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    font-family: "contralto-xsmall", sans-serif;
    position: fixed;
    flex-direction: column;
    background-color: ${(props) => props.themeContext.backgroundColor};
    background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;

    width: 100vw;
    max-width: 550px;
    height: 100dvh;
    z-index: 10;

    *, input, button, textarea, select {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
    }

    @media (min-width: 768px) {
        top: 50%;
        left: 50%;
        width: min(620px, calc(100vw - 80px));
        max-width: 620px;
        height: auto;
        max-height: calc(100dvh - 80px);
        border-radius: 18px;
        overflow: hidden;
        z-index: 1001;
        box-shadow: 0 18px 52px rgba(0, 0, 0, 0.35);
        transform: translate(-50%, -50%);
        animation: customerEditDialog 200ms ease-out;

        @keyframes customerEditDialog {
            from {
                transform: translate(-50%, calc(-50% + 18px)) scale(0.98);
                opacity: 0;
            }
            to {
                transform: translate(-50%, -50%) scale(1);
                opacity: 1;
            }
        }
    }
`;
